import '../../assets/css/index-blocks.scss';
import '../../assets/css/accordion-icon.scss';
import './solution.scss';
import './solution-preview.scss';
import './solution-objetivos.component';
import './solution-preview.component';
import { LANGUAGE } from '../../constants';

import { getText, appendText } from '../../assets/js/text-renderer';

if (DEVELOPMENT || (window['__PRERENDER_INJECTED'] && window['__PRERENDER_INJECTED'].render_text)) {
  const language = window['__PRERENDER_INJECTED'] ? window['__PRERENDER_INJECTED'].language : LANGUAGE;
  appendText(language === 'en' ? 'Solution' : 'Solución', 'pre-title');
  appendText(language === 'en' ? 'Business cases' : 'Casos de uso', 'casos-de-uso');
  appendText(
    language === 'en' ? 'Find further related cases' : 'Descubre otros casos relacionados',
    'casos-de-uso-desc'
  );
  window.dispatchEvent(new CustomEvent('rendered-text', { detail: 'keywords' }));
  window.dispatchEvent(new CustomEvent('rendered-text', { detail: 'content' }));
  window.dispatchEvent(new CustomEvent('rendered-text', { detail: 'cta' }));
}
// document.dispatchEvent(new Event('render-ready'));

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const usecase = urlParams.get('case');

getText(`solutions&filter_query[name][in]=${usecase}`).then((dict) => {
  const data = dict.stories[0].content;
  console.log(dict.stories);
  const group = dict.stories[0].full_slug.split('/')[1];
  console.log('group ', group);

  const solutionsElement = document.getElementById('goals-component');
  solutionsElement.setAttribute('content', JSON.stringify(data.objetivos));

  appendText(data.title, 'title');

  appendText(data.resultado, 'content-resultado');
  appendText(data.impacto, 'content-impacto');

  if (data.solution_img) {
    appendText(data.title_visual, 'title-visual');
    appendText(data.text_visual, 'text-visual');
    document
      .getElementById('img-visual')
      .setAttribute('srcset', `/assets/img/usecases/solution/${data.solution_img}.webp`);
  } else {
    document.getElementById('solution-visual').setAttribute('style', 'display: none;');
  }

  appendText(data.title_conclusions, 'title-conclusions');
  appendText(data.text_conclusions, 'text-conclusions');

  appendText(data.content_conclusions[0].title, 'perspectiva-1-title');
  appendText(data.content_conclusions[0].description, 'perspectiva-1-content');
  setImgIcon(data.content_conclusions[0].title, 'perspectiva-1-icon');

  appendText(data.content_conclusions[1].title, 'perspectiva-2-title');
  appendText(data.content_conclusions[1].description, 'perspectiva-2-content');
  setImgIcon(data.content_conclusions[1].title, 'perspectiva-2-icon');

  appendText(data.content_conclusions[2].title, 'perspectiva-3-title');
  appendText(data.content_conclusions[2].description, 'perspectiva-3-content');
  setImgIcon(data.content_conclusions[2].title, 'perspectiva-3-icon');

  loadGroup(data.related);
});

function setImgIcon(icon, id) {
  if (icon === 'Negocio' || icon === 'Business')
    document.getElementById(id).setAttribute('src', '/assets/iconos/cases-negocio.svg');
  else if (icon === 'Ciencia de datos' || icon === 'Data Science')
    document.getElementById(id).setAttribute('src', '/assets/iconos/cases-ciencia-datos.svg');
  else document.getElementById(id).setAttribute('src', '/assets/iconos/cases-tecnologia.svg');
}

function loadGroup(related) {
  if (!related) return;
  getText(`solutions&filter_query[name][in]=${related}`).then((dict) => {
    const solutionsElement = document.getElementById('solutions-component');
    solutionsElement.setAttribute('content', JSON.stringify(dict.stories));
  });
}
